"use client";

export { default as MitreFormComponent } from "./components/Form";
export type { MitreFormComponentProps } from "./components/Form";
